// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"524":"6d15f643","580":"0f2b8938"}[chunkId] + ".chunk.css";
};